import { addNewJob, deleteJob, editJob, getJobs } from "./jobsAPI";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

const initialState = {
  jobs: [],
  jobsCategory: "all",
  search: "",
  isLoading: false,
  isError: false,
  error: "",
};

// async thunk
export const fetchJobs = createAsyncThunk("jobs/fetchJobs", async () => {
  const jobs = await getJobs();
  return jobs;
});
export const createJob = createAsyncThunk("jobs/createJob", async (data) => {
  const job = await addNewJob(data);
  return job;
});

export const changeJob = createAsyncThunk(
  "jobs/changeJob",
  async ({ id, data }) => {
    // console.log(data);
    const job = await editJob(id, data);
    return job;
  }
);

export const removeJob = createAsyncThunk("jobs/removeJob", async (id) => {
  const job = await deleteJob(id);
  return job;
});

const jobsSlice = createSlice({
  name: "jobs",
  initialState,
  reducers: {
    defaultSort: (state, action) => {
      state.jobs.sort((a, b) => a.id - b.id);
    },
    lowToHigh: (state, action) => {
      state.jobs.sort((a, b) => a.salary - b.salary);
    },
    highToLow: (state, action) => {
      state.jobs.sort((a, b) => b.salary - a.salary);
    },
    searched: (state, action) => {
      state.search = action.payload;
    },
    jobsCategorySelected: (state, action) => {
      state.jobsCategory = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobs.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(fetchJobs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.jobs = action.payload;
        // state.savedblogs = state.blogs.filter((blog) => blog.isSaved === true);
      })
      .addCase(fetchJobs.rejected, (state, action) => {
        state.isLoading = false;
        state.jobs = [];
        state.isError = true;
        state.error = action.error?.message;
      })
      .addCase(createJob.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(createJob.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.jobs.push(action.payload);
      })
      .addCase(createJob.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error?.message;
      })
      .addCase(changeJob.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(changeJob.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;

        const indexToUpdate = state.jobs.findIndex(
          (j) => j.id === action.payload.id
        );

        state.jobs[indexToUpdate] = action.payload;
      })
      .addCase(changeJob.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error?.message;
      })
      .addCase(removeJob.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(removeJob.fulfilled, (state, action) => {
        console.log(action);
        state.isError = false;
        state.isLoading = false;

        state.jobs = state.jobs.filter((j) => j.id !== action.meta.arg);
      })
      .addCase(removeJob.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error?.message;
      });
  },
});

export default jobsSlice.reducer;

export const {
  defaultSort,
  lowToHigh,
  highToLow,
  jobsCategorySelected,
  searched,
} = jobsSlice.actions;
